import { useEffect } from 'react';
import isStandalone from 'pwa/helpers/isStandalone';
import { usePosthogCapture } from 'pwa/posthogCapture/_index';

/**
 * Reports once per load whether the app was opened from the home screen,
 * which is how we measure whether installs are actually being used.
 */
export default function useTrackStandaloneLaunch(): void {
  const capture = usePosthogCapture();

  useEffect(() => {
    if (!isStandalone()) return;
    capture.launchedStandalone();
  }, [capture]);
}
